import { render, staticRenderFns } from "./StaffKPI.vue?vue&type=template&id=27b1d210&"
import script from "./StaffKPI.vue?vue&type=script&lang=js&"
export * from "./StaffKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports